import store from '@state/store';

// eslint-disable-next-line no-undef
export default [
  {
    path: '/',
    name: 'onboarding',
    component: () => lazyLoadView(import('@views/accountsManager/onboarding.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'home' });
        } else {
          next();
        }
      },
    },
  },
  {
    path: '/trainer-onboarding',
    name: 'trainerOnboarding',
    component: () => lazyLoadView(import('@views/accountsManager/trainer-onboarding.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: () => lazyLoadView(import('@views/accountsManager/checkout.vue')),
    meta: {
      authRequired: true,
      // beforeResolve(routeTo, routeFrom, next) {
      //   if (store.getters['auth/loggedIn']) {
      //     next({ name: 'home' });
      //   } else {
      //     next();
      //   }
      // },
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/accountsManager/login.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next({ name: 'home' });
        } else {
          next();
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut');
        store.dispatch('clearAll');
        next({ name: 'login' });
      },
    },
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => lazyLoadView(import('@views/accountsManager/reset-password.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next({ name: 'home' });
        } else {
          next();
        }
      },
    },
  },
  {
    path: '/forgot-password-confirm/client',
    name: 'forgot-pass-confirm',
    component: () => lazyLoadView(import('@views/accountsManager/forgot-pass-confirm.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next({ name: 'home' });
        } else {
          next();
        }
      },
    },
  },
  {
    path: '/signup',
    name: 'signUp',
    component: () => lazyLoadView(import('@views/accountsManager/signup.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/userProfile'].successfulSignup) {
          next({ name: 'home' });
        } else if (store.getters['auth/loggedIn']) {
          next();
        } else {
          next({ name: 'onboarding' });
        }
      },
    },
  },
  {
    path: '/home',
    name: 'home',
    // for initial launch, don't route to home...
    component: () => lazyLoadView(import('@views/home/home.vue')),
    // component: () => lazyLoadView(import('@views/accountsManager/personal-all-set.vue')),
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // can make API here even if autoLogin was used...
          // await store.dispatch('auth/validate')
          //   .then(validation => {
          //     if (!validation) return next({ name: '404', params: { resource: 'Valid Token' } });
          //   });

          const initialLandingPage = store.getters['client/initialLandingPage'];
          const completedOnBoarding = store.getters['client/completedOnBoarding'];
          const isSubscribed = store.getters['client/isSubscribed'];

          if (!completedOnBoarding && isSubscribed) {
            switch (initialLandingPage) {
              case 0: {
                next({ name: 'personalInformation' });
                break;
              }
              case 1: {
                next({ name: 'personalGoals' });
                break;
              }
              case 2: {
                next({ name: 'personalMotivation' });
                break;
              }
              case 3: {
                next({ name: 'personalCurrentWeight' });
                break;
              }
              case 4: {
                next({ name: 'personalGoalWeight' });
                break;
              }
              case 5: {
                next({ name: 'personalConditions' });
                break;
              }
              case 6: {
                next({ name: 'personalLikeToTrain' });
                break;
              }
              case 7: {
                next({ name: 'personalAllSet' });
                break;
              }
              default: {
                next({ name: 'personalInformation' });
              }
            }
          } else {
            if (!isSubscribed) {
              next({ name: 'checkout' });
            }
            next();
          }
        } else {
          console.error('not logged in');
          next({ name: 'onboarding' });
        }
      },
    },
  },
  {
    path: '/nutrition',
    name: 'nutrition',
    component: () => lazyLoadView(import('@views/nutrition/nutrition.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          const isSubscribed = store.getters['client/isSubscribed'];
          if (!isSubscribed) {
            next({ name: 'checkout' });
          } else {
            next();
          }
        } else {
          next({ name: 'login' });
        }
      },
    },
  },
  {
    path: '/chat',
    name: 'chat',
    component: () => lazyLoadView(import('@views/chat/chat.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next();
        } else {
          next({ name: 'login' });
        }
      },
    },
  },
  {
    path: '/progress',
    name: 'progress',
    props: true,
    component: () => lazyLoadView(import('@views/progress/progress.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.getters['auth/loggedIn'] ? next() : next({ name: 'login' });
      },
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => lazyLoadView(import('@views/profile/profile.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.getters['auth/loggedIn'] ? next() : next({ name: 'login' });
      },
    },
    children: [
      {
        path: 'info',
        name: 'Info',
        component: () => import('@components/profile/info.vue'),
      },
      {
        path: 'subscription',
        name: 'Subscription',
        component: () => import('@components/profile/subscription.vue'),
      },
      {
        path: 'tos',
        name: 'TOS',
        component: () => import('@components/profile/tos.vue'),
      },
      {
        path: 'password',
        name: 'Password',
        component: () => import('@components/profile/password.vue'),
      },
      {
        path: 'privacy',
        name: 'Privacy',
        component: () => import('@components/profile/privacy.vue'),
      },
    ],
  },
  {
    path: '/workouts/:id',
    name: 'workoutDetail',
    props: true,
    component: () => lazyLoadView(import('@views/workouts/workout-detail.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['auth/loggedIn']) {
          next({ name: 'login' });
        }
        if (routeTo.params.workoutOption) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
    },
  },
  {
    path: '/exercises/:id',
    name: 'exercise',
    props: true,
    component: () => lazyLoadView(import('@views/exercise/exercise.vue')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['auth/loggedIn']) {
          next({ name: 'login' });
        }
        if (routeTo.params.workout) {
          next();
        } else {
          next({ name: 'home' });
        }
      },
    },
  },
  {
    path: '/signup/personal-information',
    name: 'personalInformation',
    component: () => lazyLoadView(import('@views/accountsManager/personal-information.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next();
        } else {
          next({ name: 'onboarding' });
        }
      },
    },
  },
  {
    path: '/signup/personal-goals',
    name: 'personalGoals',
    component: () => lazyLoadView(import('@views/accountsManager/personal-goals.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next();
        } else {
          next({ name: 'onboarding' });
        }
      },
    },
  },
  {
    path: '/signup/personal-motivation',
    name: 'personalMotivation',
    component: () => lazyLoadView(import('@views/accountsManager/personal-motivation.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next();
        } else {
          next({ name: 'onboarding' });
        }
      },
    },
  },
  {
    path: '/signup/personal-current-weight',
    name: 'personalCurrentWeight',
    component: () => lazyLoadView(import('@views/accountsManager/personal-current-weight.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next();
        } else {
          next({ name: 'onboarding' });
        }
      },
    },
  },
  {
    path: '/signup/personal-goal-weight',
    name: 'personalGoalWeight',
    component: () => lazyLoadView(import('@views/accountsManager/personal-goal-weight.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next();
        } else {
          next({ name: 'onboarding' });
        }
      },
    },
  },
  {
    path: '/signup/personal-conditions',
    name: 'personalConditions',
    component: () => lazyLoadView(import('@views/accountsManager/personal-conditions.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next();
        } else {
          next({ name: 'onboarding' });
        }
      },
    },
  },
  {
    path: '/signup/personal-liketotrain',
    name: 'personalLikeToTrain',
    component: () => lazyLoadView(import('@views/accountsManager/personal-like-to-train.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next();
        } else {
          next({ name: 'onboarding' });
        }
      },
    },
  },
  {
    path: '/signup/personal-allset',
    name: 'personalAllSet',
    component: () => lazyLoadView(import('@views/accountsManager/personal-all-set.vue')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          next();
        } else {
          next({ name: 'onboarding' });
        }
      },
    },
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => lazyLoadView(import('@views/terms/terms.vue')),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => lazyLoadView(import('@views/terms/privacy.vue')),
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404.vue').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
];

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading.vue').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout.vue').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  });

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children);
    },
  });
}
